import React, { useContext, useEffect, useState } from 'react'
import TableVideo from '../Video/TableVideo'
import Sidebar from '../Sidebar'
import { addcontext } from '../../ContextShare/ContextShare'
import klaimage from '../../Assets/kla-logo.png'
import Home from '../AdminHome.jsx/Home'
import { useNavigate } from 'react-router-dom'
import { GetLiveButtonApi, UpdateLive } from '../../Services/allApi'
import { Icon } from '@iconify/react/dist/iconify.js'
import { toast } from 'react-toastify'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import ConstituencyMapping from '../Kla/ConstituencyMapping'
import FlowChart from '../FlowChart'
/** @jsxImportSource @emotion/react */
import { css, keyframes } from '@emotion/react';

const scaleUp = keyframes`
  from {
    transform: translate(-50%, -50%) scale(0.5);
    opacity: 0;
  }
  to {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
`;

const styleMM = css({
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '70%',
    backgroundColor: 'rgba(255, 255, 255, 0.9)', // White background with 90% opacity
    boxShadow: 24,
    padding: '5px', // equivalent to p: 2 in MUI spacing
    maxHeight: '70%',   
    overflowY: 'hidden',
    transform: 'translate(-50%, -50%)',
    animation: `${scaleUp} 0.5s ease-out`, // Use the new scale-up animation
    backdropFilter: 'blur(10px)', // Optional: Add a blur effect to the background
});

function HomeR() {
    const { addVideo, setAddVideo } = useContext(addcontext)
    const { changeSeqNo, setChangeSeqNo } = useContext(addcontext)
    const {isSidebarCloses,setIsSidebarCloses}=useContext(addcontext)
    const navigate = useNavigate()
    const [token, setToken] = useState()
    const [isLive, setIsLive] = useState(false);
    const [isMaintenance, setIsMaintenance] = useState(false);
    const [updateResponse, setupdateResponse] = useState(1);
   const [errorMsg,setErrorMsg]=useState()
   const [FlowChartActive,setFlowChartActive]=useState(true)
   const [openSS, setOpenSS] = useState(true);
    const [isEditedSS, setIsEditedSS] = useState(1)
    const {isFlowModalOpened,setIsFlowModalOpened}=useContext(addcontext)
    const handleOpenSS = () => setOpenSS(true);
    const handleCloseSS = () => setOpenSS(false);
    useEffect(()=>{
        getLiveButtonInitial()
    },[updateResponse])

    const getLiveButtonInitial=async()=>{
        const result=await GetLiveButtonApi()
        setIsLive(result?.data?.is_active)

        console.log(result);
    }

    const toggleLive = () => {
        setIsLive(!isLive);
        updateButtonForLive()

    };

    const updateButtonForLive=async()=>{
        const token = sessionStorage.getItem('access_token');
        const reqHeader = {
            "Authorization": `${token}`
        };
        const buttonResponse=!isLive?{is_active:true}:{is_active:false}
        const result=await UpdateLive(buttonResponse,reqHeader)
        const error = result?.response?.data?.message;
        // setErrorMsg(result?.response?.data?.message)
        if(result?.status==200){
            setupdateResponse(updateResponse+1)
            toast.success('Live button updated successfully')
        }
        else{
            const errorMessage = error ?? 'There was an error updating live videos';
                // setErrorMsg(errorMessage);
                toast.error(result?.response?.data?.message??'There was an error updating live videos');
        }
        console.log(result);
    }

    const toggleMaintenance = () => {
        setIsMaintenance(!isMaintenance);
    };
    
    useEffect(() => {
        const tokenv = sessionStorage.getItem('access_token')
        setToken(tokenv)
        if (!tokenv) {
            navigate('/skyblue')
        }

    }, [token])

    useEffect(()=>{
        setTimeout(()=>{
            setFlowChartActive(false)
            setOpenSS(false)
            setIsFlowModalOpened(false)
        },10000)
    },[])

    useEffect(()=>{
        if(!openSS){
            setFlowChartActive(false)
            setIsFlowModalOpened(false)
        }
    },[openSS])

    return (
        <>
            <div className='flex w-full h-full ' style={{ fontFamily: 'ropa sans' }}>
                <div className='flex flex-col w-full h-full'>

                    <div className='w-full h-24 flex flex-row justify-between bg-success rounded border ' style={{height:'13vh'}}>
                        {/* logo */} 
                        <div className='w-2/12 flex items-center '>
                            <img src={klaimage} className='w-6/12 ms-12 lg:flex hidden p-1' alt="" />
                            </div>

                            <div className='flex items-center' title='Full screen' onClick={()=>setIsSidebarCloses(!isSidebarCloses)}>
                            <Icon icon="teenyicons:expand-solid" className='text-2xl font-bold  cursor-pointer'/>
                            </div>


                        <div className='w-10/12 flex flex-row justify-center gap-20'>

                            <div className='flex justify-center items-center w-full flex-row'>
                                <div className='flex w-7/12 justify-end'> 
                                <h1 className='text-4xl text-blue-gray-700 text-center font-bold '>Admin Dashboard</h1>
                                </div>

                                <div className='flex flex-row justify-end gap-5 w-5/12 me-5'>
            <div>
                <button
                    className={`w-full rounded-full py-2 px-6 transition-colors duration-300 shadow-lg transform hover:scale-105 focus:outline-none ${
                        isLive
                            ? 'bg-green-500 text-white hover:bg-green-600'
                            : 'bg-gray-300 text-blue-gray-900 hover:bg-gray-400'
                    }`}
                    onClick={toggleLive}
                >
                    {isLive ? 'Live Button on' : 'Live Button off'}
                </button>
            </div>
            <div>
                <button
                    className={`w-full rounded-full py-2 px-6 transition-colors duration-300 shadow-lg transform hover:scale-105 focus:outline-none ${
                        isMaintenance
                            ? 'bg-green-500 text-white hover:bg-green-600'
                            : 'bg-gray-300 text-blue-gray-900 hover:bg-gray-400'
                    }`}
                    onClick={toggleMaintenance}
                >
                    {isMaintenance ? 'Maintenance mode on' : 'Maintenance mode off'}
                </button>
            </div>
        </div>

                            </div>
                            {/* button one */}

                            {/* <div className={`flex md:w-52 w-4/12 items-center h-full`}>

                                <button className='flex w-full h-2/5 justify-center items-center rounded-xl  cursor-pointer text-white hover:border border-blue-gray-800' style={{ backgroundColor: '#0070FF' }}
                                    onClick={handleAddvideo}>
                                    <i class={`fa-solid ${addVideo ? 'fa-xmark' : 'fa-plus'} md:me-2 me-1`}></i>
                                    <span className='lg:text-sm text-xs'>{!addVideo ? 'Add new videos' : 'Close'}</span>
                                </button></div> */}

                            {/* button two */}

                            {/* <div className='flex md:w-52 w-4/12 items-center h-full '>
                                <button className='flex w-full h-2/5 justify-center items-center rounded-xl  cursor-pointer text-white hover:border border-blue-gray-800' style={{ backgroundColor: '#0070FF' }}
                                    onClick={handleChangeseqNo}>
                                    <i class={`fa-solid ${changeSeqNo ? 'fa-xmark' : 'fa-pen-to-square'} md:me-2 me-1`}></i>
                                    <span className='lg:text-sm text-xs'>{!changeSeqNo ? 'Change sequence number' : 'Close'}</span>
                                </button>
                            </div> */}

                        </div>

                    </div>

                    <div className='flex flex-row'>

                        {/*SIDEBAR Sidebar displayed on large screens  */}
                        <div className={`${isSidebarCloses&&'hidden'} md:w-4/12 lg:w-3/12 xl:w-2/12`}>
                        <Sidebar />
                        </div>
                        


                        {/* sidebar for smaller screens */}
                        {/*If isSideBarOpen is true then sidebar is visible otherwise sidebar is hidden */}

                        {/* <div className={`md:w-6/12  w-9/12 lg:hidden flex  bg-primary   flex-col text-white rounded-r z-40   `} style={{ height: '87vh' }}>
             <Sidebar />
         </div>
      */}

                        {/* Table */}
                        {/* Based on the content on the tableSelectedFromSidebar the corresponding table is displayed on screen */}
                        {(!isFlowModalOpened)?
                        <div className={`${isSidebarCloses?'w-full':'lg:w-9/12 xl:w-10/12 w-full'} overflow-y-scroll pt-2 px-2 `} style={{ height: '87vh' }}>
                            <Home />
                          
                        </div>
                         :
                         <Modal
                         open={openSS}
                         onClose={handleCloseSS}
                         aria-labelledby="modal-modal-title"
                         aria-describedby="modal-modal-description"
                     >
                         <Box sx={styleMM}>
                            <div className='flex justify-end'><button onClick={handleCloseSS} className='px-2 border border-red-500 bg-white hover:bg-red-500 hover:text-white text-red-500 transform duration-500 ease-in-out flex flex-row gap-1 items-center'><Icon icon="iconamoon:close" className='text-xl' /></button></div>
                             <FlowChart height={'66vh'} width={'68vw'} bg={true} />
                         </Box>
                     </Modal>}
                    </div>
                </div></div>
        </>
    )
}

export default HomeR
